module.exports = __webpack_public_path__ + "static/media/photo216.5f5b280d.jpg";